import { createUseStyles } from '@glu/theming';

const styles = ({ mobilegrid }) => ({
  rendererRoot: {
    margin: '1rem 1rem 0',
    paddingBottom: 70
  },
  tableMain: {
    width: '100%',
    borderCollapse: 'collapse',
    '& thead th': {
      borderBottom: mobilegrid.headerBorder,
      paddingBottom: '0.5rem'
    }
  },
  bulkActionSvg: {
    '& input[type="checkbox"] + div svg': {
      width: 16,
      height: 16
    }
  },
  noContent: {
    color: mobilegrid.noContentText,
    padding: 20,
    textAlign: 'center'
  },
  rightAlign: {
    paddingLeft: '0px',
    textAlign: 'right !important'
  },
  leftAlign: {
    paddingLeft: '10px',
    textAlign: 'inherit'
  }
});

export default createUseStyles(styles);
